/* eslint-disable import/order */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { StandardObjectTypeApi } from 'api';
import { RootState } from 'app';

export const findStandardObjectType = createAsyncThunk<any>(
  'standardObjectType/findStandardObjectType',
  async (options, { rejectWithValue }) => {
    try {
      return await StandardObjectTypeApi.find();
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface StandardObjectTypeState {
  list: any[];
  isLoading: boolean;
  initLoading: boolean;
}

const initialState: StandardObjectTypeState = {
  list: [],
  isLoading: false,
  initLoading: false,
};

const standardObjectTypeSlice = createSlice({
  name: 'standardObjectType',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findStandardObjectType.fulfilled, (state, { payload }) => {
      const { data } = payload;
      state.list = data;
      state.initLoading = true;
    });
  },
});

const { reducer: standardObjectTypeReducer } = standardObjectTypeSlice;

export default standardObjectTypeReducer;

export const selectStandardObjectType = (
  state: RootState
): StandardObjectTypeState =>
  state.standardObjectType as StandardObjectTypeState;
